import { logger } from 'lib/analytics/logger'
import { apiV2 } from 'lib/api/v2'
import useSWRMutation from 'swr/mutation'

type ReadNotificationsPayload = {
  ids: string[]
}

async function fetcher(
  _: [string],
  { arg }: { arg: ReadNotificationsPayload }
) {
  try {
    await apiV2.put('private/notifications/status', {
      data: {
        ids: arg.ids,
        status: 'READ'
      }
    })
  } catch (err) {
    logger.error('Error reading notifications', arg, err)
  }
}

export const useReadNotifications = () =>
  useSWRMutation(['readNotifications'], fetcher)
